import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useMe } from '@/hooks/useMe';
import { useAutoActivateOrg } from '@/hooks/useAutoActivateOrg';
import { ApiError } from '@/api/client';
import { ClaimPending } from './ClaimPending';

/**
 * Root-level dispatcher. After sign-in lands here. We ask `/portal/me` once and
 * redirect to the correct surface for the user's role.
 */
export function RoleRouter(): JSX.Element {
  useAutoActivateOrg();
  const me = useMe();

  if (me.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Loading…
      </div>
    );
  }
  if (me.error instanceof ApiError && me.error.code === 'OUTREACH_INVITER_NOT_FOUND') {
    return <ClaimPending />;
  }
  if (me.error) {
    return <p className="p-8 text-sm text-destructive">{(me.error as Error).message}</p>;
  }
  if (!me.data) return <></>;

  return <Navigate to={me.data.role === 'admin' ? '/admin' : '/portal'} replace />;
}
